import React, { Component } from 'react';  
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';

class KnowMore extends Component {
  state = {
    rotateNum: 0
  }

  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "华夏智投组合介绍";
  }

  goBack = () => {
     hashHistory.goBack();
  }

  render() {
    return (
      <div style={{background: "#fff", display: "-webkit-flex", WebkitFlexDirection: "column", height: "100%"}}>
        <NavigatorMain>
          <div style={{background: "rgb(38, 42, 48)", display: "-webkit-flex", height: 44, WebkitAlignItems: "center", WebkitFlexDirection: "row", WebkitJustifyContent: "space-between"}}>
            <div style={{width: 100}}>
              <img onClick={this.goBack}  alt="" style={{height: 40, width: 40}} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div style={{fontSize: 15, color: "#fff", WebkitFlex: 1, textAlign: "center"}}>华夏智投组合介绍</div>
            <div style={{fontSize: 15, color: "#fff", paddingRight: 13, width: 100, textAlign: "right"}}></div>
          </div>
        </NavigatorMain>
        <div style={{fontSize: 18, paddingLeft: 13, paddingRight: 13, paddingTop: 13, WebkitFlex: 1, paddingBottom: 13}}>
          {this.props.location.state.content}
        </div>
      </div>
    );
  }
}

export default KnowMore;


// WEBPACK FOOTER //
// ./src/components/recommend/KnowMore.js